import { createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#d72426',
    },
    secondary: {
      main: '#999',
    },
  },
});

export default theme;
